import { useEffect, useState, Suspense } from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import { Outlet } from "react-router";

function DashboardLayout() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768; // md breakpoint
      setIsMobile(mobile);

      // On mobile, sidebar should be closed by default
      if (mobile && isSidebarOpen) {
        setSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Load sidebar state from localStorage only for desktop
  useEffect(() => {
    if (!isMobile) {
      const stored = localStorage.getItem("sidebar-open");
      if (stored !== null) {
        setSidebarOpen(stored === "true");
      }
    }
  }, [isMobile]);

  const toggleSidebar = () => {
    const newState = !isSidebarOpen;
    setSidebarOpen(newState);

    // Only save to localStorage on desktop
    if (!isMobile) {
      localStorage.setItem("sidebar-open", newState.toString());
    }
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 via-blue-50/20 to-gray-50 text-gray-900 min-h-screen relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-indigo-400/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
        <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-purple-400/5 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
      </div>

      <div className="flex h-screen relative z-10">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />

        <div
          className={`flex-1 flex flex-col transition-all duration-300 min-w-0`}
        >
          <Header onToggleSidebar={toggleSidebar} />

          {/* Main content area */}
          <main className="flex-1 overflow-auto">
            <div className="p-4 sm:p-6 lg:p-8">
              <Suspense
                fallback={
                  <div className="h-64 flex items-center justify-center">
                    Loading...
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
